<template>
  <b-modal id="addphone" size="lg" ref="modalAddPhone" :title="$t('phones.add_title')" @ok="handleStorePhone" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
    <b-tabs content-class="mt-3">
      <b-tab title="Должника" active @click="toogleStoreDebtor(true)">
        <div class="form-group">
          <label for="StorePhone" class="col-form-label">{{ $t('phones.phone') }}</label>
          <input type="text" class="form-control" v-mask="phonemask" v-model="storephone.phone" :class="{'is-invalid': errors.phone }" id="StorePhone" :placeholder="$t('placeholder.enter_phone')">
          <span v-if="errors.phone" class="invalid-feedback">
              <strong>{{ errors.phone ? errors.phone[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreType" class="col-form-label">{{ $t('app.type') }}</label>
          <select v-model="storephone.type_id" class="form-control" id="StoreType" :class="{'is-invalid': errors.type_id }">
            <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
            <option v-for="type in listPhoneTypes" :value="type.id" :key="type.id" >
              {{ type.name }}
            </option>
          </select>
          <span v-if="errors.type_id" class="invalid-feedback">
              <strong>{{ errors.type_id ? errors.type_id[0] : '' }}</strong>
          </span>
        </div>
      </b-tab>
      <b-tab title="Контактного лица" @click="toogleStoreDebtor(false)">
        <div class="form-group">
          <label for="Storephone" class="col-form-label">{{ $t('phones.phone') }}</label>
          <input type="text" class="form-control" v-mask="phonemask" v-model="storephone.phone" :class="{'is-invalid': errors.phone }" id="Storephone" :placeholder="$t('placeholder.enter_phone')">
          <span v-if="errors.phone" class="invalid-feedback">
              <strong>{{ errors.phone ? errors.phone[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreType1" class="col-form-label">{{ $t('phones.type') }}</label>
          <select v-model="storephone.type_id" class="form-control" id="StoreType1" :class="{'is-invalid': errors.type_id }" >
            <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
            <option v-for="type in listPhoneTypes" :value="type.id" :key="type.id" >
              {{ type.name }}
            </option>
          </select>
          <span v-if="errors.type_id" class="invalid-feedback">
              <strong>{{ errors.type_id ? errors.type_id[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreContactface"> {{ $t('contact_faces.new') }}</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control" v-model="storephone.contactfacename" id="StoreContactface" :placeholder="$t('placeholder.enter_contact_face_fullname')" :class="{'is-invalid': errors.contactfacename }">
            <span v-if="errors.contactfacename" class="invalid-feedback">
                <strong>{{ errors.contactfacename ? errors.contactfacename[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="storecontype" class="col-form-label">{{ $t('contact_faces.type') }}</label>
          <select class="form-control" id="storecontype" v-model="storephone.contactface_type" :class="{'is-invalid': errors.contactface_type }">
              <option selected="true" value="" disabled>{{ $t('placeholder.select_contactface_type') }}</option>
              <option v-for="type in listContactfaceTypes" :value="type.id" :key="type.id">
                {{type.name}}
              </option>
          </select>
          <span v-if="errors.contactface_type" class="invalid-feedback" >
              <strong>{{ errors.contactface_type ? errors.contactface_type[0] : '' }}</strong>
          </span>
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      storephone: {
        debtor_iin: '',
        phone: '',
        type_id: '',
        contactfacename: '',
        contactface_id: '',
        contactface_type: '',
        is_debtor: true,
      },
      errors: {},
      phonemask: {
        mask: '+7(###) ###-##-##',
        autoUnmask: true,
        showMaskOnHover: false,
      },
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'listPhoneTypes',
      'listContactfaceTypes',
      'debt',
    ]),
  },
  mounted() {
    this.GET_LIST_PHONE_TYPES();
    this.GET_LIST_CONTACTFACE_TYPES();
  },
  methods: {
    ...mapActions([
      'STORE_PHONE',
      'GET_LIST_PHONE_TYPES',
      'GET_PHONES',
      'GET_LIST_CONTACTFACE_TYPES',
    ]),

    clearPhoneModal() {
      this.storephone = {
        debtor_iin: '',
        phone: '',
        type_id: '',
        contactfacename: '',
        contactface_id: '',
        contactface_type: '',
      };
      this.errors = {};
    },

    toogleStoreDebtor(isDebtor) {
      this.clearPhoneModal();
      this.storephone.is_debtor = isDebtor;
    },

    handleStorePhone(evt) {
      evt.preventDefault();
      this.storePhone();
      this.isProcessing = true;
    },

    storePhone() {
      this.storephone.debtor_iin = this.debt.debtor_iin;
      this.STORE_PHONE(this.storephone)
        .then(() => {
          this.$refs.modalAddPhone.hide();
          this.GET_PHONES(this.storephone.debtor_iin);
          this.clearPhoneModal();
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
